import * as React from 'react';

import classNames from 'classnames';

import { IconConfig, IconDialogues, IconNotification } from '@base/assets/icons';
import { getConfig, URLS } from '@base/constants';
import { useIsAppsSeoPage } from '@base/hooks';
import { isMobileScreen, translations } from '@base/utils';

import { BurgerButton } from '@ui/BurgerButton';

import { Logo, LogoTwa } from '../Logo';
import { TopMenuIconLink } from '../TopMenuIconLink';
import { TopMenuPageTitle } from '../TopMenuPageTitle';

import s from './Header.scss';

export interface IHeaderProps {
	refProp: React.RefObject<HTMLDivElement>;
	className?: string;
	isBurgerInBackState?: boolean;
	counters?: {
		notifies?: number;
		dialogues?: number;
	};
	onBurgerBtnClick?(): void;
	pageTitle?: string;
	isShowIcons?: boolean;
	isTransparent?: boolean;
}

export const Header: React.FC<IHeaderProps> = (props: IHeaderProps) => {
	const {
		className,
		counters: { notifies, dialogues },
		isBurgerInBackState,
		onBurgerBtnClick,
		pageTitle,
		isShowIcons,
		isTransparent,
	} = props;
	const isAppsSeoPage = useIsAppsSeoPage();
	const { isTwa, holidaysConfig } = getConfig();
	let burgerColor = '';

	if (isTwa) {
		if (isTransparent && isMobileScreen()) {
			burgerColor = '#fff';
		}
	}

	return (
		<div
			ref={props.refProp}
			className={
				classNames(
					s.block,
					{ [s.blockTransparent]: (isTransparent && isMobileScreen()) },
					className,
				)}
		>
			{ isTwa
				? <LogoTwa className={s.logo} src={holidaysConfig.logoUrl} />
				: <Logo className={s.logo} src={holidaysConfig.logoUrl} />
			}
			<div className={s.titleWrapper}>
				<BurgerButton
					className={classNames(s.burgerBtn)}
					isBackState={isBurgerInBackState}
					onClick={onBurgerBtnClick}
					customColor={burgerColor}
				/>
				{ pageTitle && <TopMenuPageTitle
					className={classNames(s.title, { [s.titleHidden]: isAppsSeoPage && isTransparent && isMobileScreen() })}
					title={pageTitle}
				/> }
			</div>
			{ isShowIcons && <div className={classNames(s.item, s.icons)}>
				<TopMenuIconLink
					url={URLS.DIALOGUES}
					icon={IconDialogues}
					title={translations.common('dialogues')}
					notify={dialogues}
				/>
				<TopMenuIconLink
					url={URLS.NOTIFICATIONS}
					icon={IconNotification}
					title={translations.common('notifications')}
					notify={notifies}
				/>
				<TopMenuIconLink
					classNameIcon={s.iconsItemConfig}
					url={URLS.APP_CONFIGS}
					icon={IconConfig}
					title={translations.common('configs')}
				/>
			</div>}
		</div>
	);
};
